import { selectFootTrafficExecutiveSummary } from '@/helpers/attribution/footTrafficInsights';
import { useAppSelector } from '@/store/hooks';
import { Box, Skeleton, Typography } from '@mui/material';

const InsightSummaryBox = () => {
  const { loading, text } = useAppSelector(selectFootTrafficExecutiveSummary);

  return (
    <Box
      sx={{
        p: 2.5,
        borderRadius: 1,
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        '@media print': { p: 1.5, breakAfter: 'auto', breakInside: 'avoid' },
      }}
      className='col-span-4'
    >
      <Typography variant='overline' sx={{ color: 'text.secondary', letterSpacing: 1 }}>
        Executive Summary
      </Typography>
      {loading ? (
        <Skeleton variant='text' width='90%' sx={{ mt: 0.5 }} />
      ) : (
        <Typography variant='body1' sx={{ mt: 0.5, color: 'text.primary' }}>
          {text}
        </Typography>
      )}
    </Box>
  );
};

export default InsightSummaryBox;
